
export enum TypeAvis {
  externe = 1,
  public = 2,
  partage = 3,
}

export const TypeAvisLabel = new Map<number, string>([
  [TypeAvis.externe, 'Externe'],
  [TypeAvis.public, 'Public'],
  [TypeAvis.partage, 'Partagé'],
]);
